import React from "react";

const ColorCompo = (props) => {
  const { newfil } = props;
  return (
    <>
      <label>
        <input type="radio" className="form-check-input" {...props} />{" "}
        <span
          className={`status-text status_label_details`}
          style={{
            backgroundColor: newfil.backgroundColor,
            color: "#" + newfil.color,
            border: `1px solid ${newfil.borderColor}`,
          }}
        >
          {props.textValue || "Status"}
        </span>
      </label>
    </>
  );
};

export default ColorCompo;
